import React from 'react';

const ArrowRight = (props) => (
  <svg viewBox="0 0 25 25" {...props}>
    <path d="M24.904 11.929c0-.105-.104-.21-.209-.314-.105-.105-.21-.21-.314-.21L11.93.524C11.406-.105 10.464 0 9.836.628c-.314.21-.418.628-.314 1.046 0 .314.21.733.523 1.047l9.523 8.37H1.57c-.419 0-.733.105-1.047.42-.314.313-.418.627-.418 1.046 0 .837.627 1.465 1.465 1.465h17.998L9.94 22.393c-.628.628-.628 1.57-.105 2.093.314.314.733.418 1.151.418h.105c.314 0 .628-.104.837-.209L24.59 13.603c.105-.104.21-.21.21-.314l.104-.104c.105-.21.21-.419.21-.733-.105-.104-.105-.314-.21-.523z"></path>
  </svg>
);

export default ArrowRight;
